/**
 * 系统管理 用户管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="手机号">
        <el-input size="small" v-model="formInline.mobile" placeholder="输入手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="id" label="序号" >
      </el-table-column>
      <el-table-column sortable prop="nickname" label="昵称" >
        <template slot-scope="scope">
          {{  scope.row.nickname ? scope.row.nickname  :'-'}}
        </template>
      </el-table-column>
      <el-table-column sortable prop="tel" label="手机号" >
      </el-table-column>
      <el-table-column sortable prop="usable_fund" label="账户余额(元)" >
        <template slot-scope="scope">
          {{  scope.row.usable_fund /100}}
        </template>
      </el-table-column>
      <el-table-column sortable prop="backend_fee" label="后台充值(元)" >
        <template slot-scope="scope">
          {{  scope.row.backend_fee /100}}
        </template>
      </el-table-column>
      <el-table-column sortable prop="plate_num" label="绑定车牌数" >
      </el-table-column>

      <el-table-column sortable prop="created_at" label="注册时间" >
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <!-- <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">设置站点白名单</el-button> -->
          <!-- <el-button size="mini" type="primary" @click="handlPlate(scope.$index, scope.row)">绑定车牌</el-button> -->
          <el-button size="mini" type="primary"  @click="getAppUserFound(scope.row.id,scope.row.tel,scope.row.usable_fund,scope.row.backend_fee )">调整余额</el-button>
          <el-button size="mini" type="primary"  @click="getAppUserPlate(scope.row.id)">车牌信息</el-button>
          <el-button size="mini" type="primary"  @click="getAppUserCharge(scope.row.id)">充值记录</el-button>
          <el-button size="mini" type="primary"  @click="getBackendFeeLog(scope.row.id)">流水记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog title="充值记录" :visible.sync="chargeFormVisible" width="50%" @click="closeChargeDialog">
        <el-table size="small" :data="chargeData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column sortable prop="swift_no" label="订单号" >
        </el-table-column>
        <el-table-column sortable prop="create_time" label="创建时间" >
        </el-table-column>
        <el-table-column sortable prop="fee" label="充值金额" >
          <template slot-scope="scope">
            {{  scope.row.fee/100}}元
          </template>
        </el-table-column>
        <el-table-column sortable prop="give" label="赠送金额" >
          <template slot-scope="scope">
            {{  scope.row.give/100}}元
          </template>
        </el-table-column>
        <el-table-column sortable prop="withdraw_status" label="支付状态" >
        </el-table-column>
        <el-table-column sortable prop="order_type" label="订单类型" >
        </el-table-column>
        <el-table-column sortable prop="tran_id" label="微信流水号" >
        </el-table-column>
        <el-table-column sortable prop="pay_time" label="支付时间" >
        </el-table-column>
        <el-table-column sortable prop="back_time" label="退款时间" >
        </el-table-column>
        <el-table-column sortable prop="back_fee" label="退款金额" >
          <template slot-scope="scope" v-if="scope.row.back_time">
            {{  scope.row.back_fee/100}}元
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="tablepageparm" @callFather="callChargeFather"></Pagination>
    </el-dialog>
    <el-dialog title="流水记录" :visible.sync="priceFormVisible" width="50%" @click="closePriceDialog">
        <el-table size="small" :data="priceData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column sortable prop="id" label="ID" >
        </el-table-column>
        <el-table-column sortable prop="create_time" label="创建时间" >
        </el-table-column>
        <el-table-column sortable prop="money" label="金额" >
          <template slot-scope="scope">
            {{  scope.row.money/100}}元
          </template>
        </el-table-column>
        <el-table-column sortable prop="detail" label="备注" >
        </el-table-column>
        <el-table-column sortable prop="income" label="流水类型" >
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="tablepageparm" @callFather="callPriceFather"></Pagination>
    </el-dialog>
    <el-dialog title="车牌记录" :visible.sync="plateFormVisible" width="50%" @click="closePlateDialog">
        <el-table size="small" :data="plateData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column sortable prop="id" label="ID" >
        </el-table-column>
        <el-table-column sortable prop="plate" label="车牌" >
        </el-table-column>
        <el-table-column sortable prop="timestamp" label="创建时间" >
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="tablepageparm" @callFather="callPriceFather"></Pagination>
    </el-dialog>


    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm"  ref="editForm">
        <el-form-item label="场地名称:">
          <el-select v-model="editForm.station_id" placeholder="请选择场地"  multiple>
            <el-option v-for="item in station_names" :label="item.station_name" :value="item.id" :key="item.station_name"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>


    <el-dialog title="调整余额" :visible.sync="editFeeFormVisible" width="50%" @click="closeFeeDialog">

      <el-form label-width="120px" :model="editFeeForm"  ref="editFeeForm">
        <el-form-item label="手机号" prop="tel">
            <el-input size="small" v-model="editFeeForm.tel" auto-complete="off" placeholder="手机号" disabled></el-input>
          </el-form-item>
          <el-form-item label="充值余额" prop="usable_fund">
            <el-input size="small" v-model="editFeeForm.usable_fund" auto-complete="off" placeholder="充值余额"></el-input>
          </el-form-item>
          <el-form-item label="后台赠送余额" prop="backend_fee">
            <el-input size="small" v-model="editFeeForm.backend_fee" auto-complete="off" placeholder="后台赠送余额"></el-input>
          </el-form-item>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeFeeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitFeeForm('editFeeForm')">保存</el-button>
      </div>
    </el-dialog>
</div>
</template>

<script>
// 导入请求方法
import { getStationNames } from '../../api/station'
import { getUser,updateAppUser,updateAppUserFee } from '../../api/price'
import Pagination from '../../components/Pagination'
import { getBackendFeeLog,getAppUserCharge, getAppUserPlate} from '../../api/money'
export default {
  data() {
    return {
      chargeFormVisible: false,
      priceFormVisible: false,
      plateFormVisible: false,
      editFeeFormVisible: false,
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        station_id:'',
      },
      editFeeForm: {
        id:'',
        tel:'',
        usable_fund:0,
        backend_fee:0,
      },
      // 请求数据参数
      formInline: {
        per_page: 10,
        limit: 10,
        mobile: '',
      },
      tableInline: {
        per_page: 10,
        limit: 10,
        stock_user_id:0,
      },
      station_names:[],
      //用户数据
      listData: [],
      chargeData:[],
      priceData:[],
      plateData:[],

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      tablepageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getStationNames()
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    closeDialog() {
      this.editFormVisible = false
    },
    closeFeeDialog() {
      this.editFeeFormVisible = false
    },
    closePriceDialog() {
      this.chargeFormVisible = false
    },
    closePlateDialog() {
      this.plateFormVisible = false
    },
    closeChargeDialog() {
      this.priceFormVisible = false
    },
    getPrice(){
      getPrice().then(res => {
        if (res.code == 0) {
            this.priceList = res.data.data
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    getBackendFeeLog(id) {
      this.priceFormVisible = true
      this.tableInline.stock_user_id = id
      getBackendFeeLog(this.tableInline).then(res => {
          this.loading = false
          this.priceData = res.data.data
          this.tablepageparm.currentPage = res.data.current_page
          this.tablepageparm.pageSize = res.data.per_page
          this.tablepageparm.total = res.data.total
      })
    },
    getAppUserCharge(id) {
      this.chargeFormVisible = true
      this.tableInline.stock_user_id = id
      getAppUserCharge(this.tableInline).then(res => {
          this.loading = false
          this.chargeData = res.data.data
          this.tablepageparm.currentPage = res.data.current_page
          this.tablepageparm.pageSize = res.data.per_page
          this.tablepageparm.total = res.data.total
      })
    },
    getAppUserPlate(id) {
      this.plateFormVisible = true
      this.tableInline.stock_user_id = id
      getAppUserPlate(this.tableInline).then(res => {
          this.loading = false
          this.plateData = res.data.data
          console.log(this.plateData)
          this.tablepageparm.currentPage = res.data.current_page
          this.tablepageparm.pageSize = res.data.per_page
          this.tablepageparm.total = res.data.total
      })
    },
    getStationNames(){
      getStationNames().then(res => {
        if (res.code == 0) {
            this.station_names = res.data
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
     //显示编辑界面
     handleEdit: function(index, row) {
      this.editFormVisible = true
      this.editForm =  {
          station_id:''
        }
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.station_id = row.station_id != null && row.station_id.length > 0? row.station_id.split(',').map(Number) :''
        this.editForm.id = row.id
      } else {
        this.title = '添加'
        this.editForm =  {
          station_id:''
        }
      }
    },
    getAppUserFound(id,tel,usable_fund,backend_fee) {
      this.editFeeFormVisible = true
      console.log(usable_fund)
      this.editFeeForm =  {
          id:id,
          tel:tel,
          usable_fund:usable_fund/100,
          backend_fee:backend_fee/100,
        }
    },

    // 获取数据方法
        // 获取公司列表
    getdata() {
      this.loading = true
      getUser(this.formInline).then(res => {
        if (res.code == 0) {
          this.loading = false
          this.listData = res.data.data
          this.pageparm.currentPage = res.data.current_page
          this.pageparm.pageSize = res.data.per_page
          this.pageparm.total = res.data.total
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    callPriceFather(parm) {
      this.tableInline.page = parm.currentPage
      this.tableInline.limit = parm.pageSize
      this.getBackendFeeLog(this.tableInline.stock_user_id)
    },
    callChargeFather(parm) {
      this.tableInline.page = parm.currentPage
      this.tableInline.limit = parm.pageSize
      this.getAppUserCharge(this.tableInline.stock_user_id)
    },
    submitFeeForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editFeeForm.id){
            this.editFeeForm.usable_fund = this.editFeeForm.usable_fund*100
            this.editFeeForm.backend_fee = this.editFeeForm.backend_fee*100
            updateAppUserFee(this.editFeeForm.id,this.editFeeForm)
            .then(res => {
              this.editFeeFormVisible = false
              this.loading = false
              if (res.code ==0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFeeFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }
        } else {
          return false
        }
      })
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.id){
            updateAppUser(this.editForm.id,this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code ==0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }
        } else {
          return false
        }
      })
    },





  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/system/PlatformUser.vue